<div class="image" *ngIf="isHidden">
    <img [src]="image.imgURL" [alt]="product.name" (error)="onErrorFn()">
</div>